import WemburyCoast from "../Assets/Photos/Wembury-Coast.jpeg";
import Seo from "../Components/Seo";

const testimonials = [
  {
    name: "",
    text: "Having hypnotherapy with Carly was like a spa break for my brain every week. My life greatly improved from the very first session and my mind was quiet and settled for the first time ever. I felt safe and listened to with Carly, she worked around my schedule so that I was able to fully unwind and it helped me change my life. Thank you so much!"
  },
  {
    name: "",
    text: "Having never had hypnotherapy before nor knowing anything much about it, I didn't know what to expect. Carly made the sessions very relaxing, positive and accessible. Info and change seeped in to me both unconsciously, and from actively learning to think differently. The track was great to have to aid sleep, and also the fact of having it in itself created reassurance that there was a tool to help. She explained things patiently and helpfully, in a comfortable environment and created a lot of hope for me. I'm so grateful. It's a really interesting subject and I definitely want to learn and practice more after this - thank you!"
  },
  {
    name: "",
    text: `I originally decided to try hypnotherapy with Carly to help me get a handle on the extremes I often found myself in around diet and wellness — years of being either completely in control or totally out of control. I just wanted to be on a level standing.
What I got from the sessions, though, was so much more than I expected.
 The sense of calm and lightness I felt immediately afterwards carried through into my everyday life. I became less reactive, more present with my partner and daughter, and less concerned with the things that had previously made me feel insecure or as though I wasn't enough, or wasn't doing enough.
Instead, I found a sense of contentment in who I am and the life I'm building. The sessions helped me in ways I didn't even realise I needed, but now I can see just how important and transformative they were.
I'm incredibly grateful for the positive impact they've had on both my mindset and my daily life.`
  }
];

export default function Testimonials() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 pb-10">
      <Seo
        title="Testimonials"
        description="Read real client experiences of solution focused hypnotherapy with Carly at Calm Coast Hypnotherapy."
        path="/testimonials"
      />
      <section className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-3">
          <p className="text-sm font-semibold uppercase tracking-wide text-coastal-600">Kind Words</p>
          <h1 className="mt-2 font-roboto text-4xl font-semibold text-coastal-800">Testimonials</h1>
          <p className="mt-3 text-slate-700">
            Kind words from clients who have experienced positive change through hypnotherapy.
          </p>
        </div>
        <div className="md:col-span-2">
          <img src={WemburyCoast} alt="Wembury beach coastline" className="h-full min-h-[240px] w-full rounded-2xl object-cover" />
        </div>
      </section>

      <section className="grid gap-4 md:grid-cols-2">
        {testimonials.map((item, index) => (
          <article key={index} className="rounded-2xl bg-coastal-50 p-5 ring-1 ring-coastal-100">
            <h2 className="font-roboto text-lg font-semibold text-coastal-800">
              {item.name ?? ""}
            </h2>
            <p className="mt-2 text-slate-700 whitespace-pre-line">&quot;{item.text}&quot;</p>
          </article>
        ))}
      </section>
    </div>
  );
}
